import { v4 as uuidv4 } from 'uuid';

import { getDateObject, getDateString } from '../../../../../../../../../../../../../../utils/dateUtil';

export const createRow = ({
  id = null,
  label = '',
  date = null,
  policyTypeId = null,
  note = '',
  isExpanded = false
} = {}) => ({
  key: uuidv4(),
  id,
  label: label || '',
  date: getDateObject(date),
  policyTypeId,
  note: note || '',
  isExpanded
});

/**
 * Rows for expirations already saved on a document (camelCased `insurance_document_expirations`).
 */
export const buildRowsFromExpirations = (expirations = []) => expirations.map(expiration => createRow({
  id: expiration.id,
  label: expiration.name,
  date: expiration.expiresAt,
  policyTypeId: expiration.insurancePolicyTypeId,
  note: expiration.note
}));

export const rowToPayload = row => ({
  name: row.policyTypeId ? null : row.label.trim() || null,
  note: row.note.trim() || null,
  insurance_policy_type_id: row.policyTypeId,
  expires_at: getDateString(row.date)
});

const samePayload = (a, b) => JSON.stringify(rowToPayload(a)) === JSON.stringify(rowToPayload(b));

/**
 * Splits staged rows into the API calls needed to make the server match them.
 */
export const diffExpirationRows = (rows, originalRows) => {
  const originalById = new Map(originalRows.map(row => [row.id, row]));
  const stagedIds = new Set(rows.filter(row => row.id).map(row => row.id));

  return {
    creates: rows.filter(row => !row.id).map(rowToPayload),
    updates: rows
      .filter(row => row.id && originalById.has(row.id) && !samePayload(row, originalById.get(row.id)))
      .map(row => ({ id: row.id, data: rowToPayload(row) })),
    deletes: originalRows.filter(row => !stagedIds.has(row.id)).map(row => row.id)
  };
};

export const soonestDate = rows => rows.reduce((soonest, row) => {
  if (!row.date) return soonest;
  if (!soonest || row.date < soonest) return row.date;

  return soonest;
}, null);

export const policyTypeLabel = (policyTypes, policyTypeId) => {
  if (!policyTypeId) return null;

  return policyTypes.find(type => type.id === policyTypeId)?.displayName || 'Policy Type';
};
